import * as React from 'react';
import { connect } from 'react-redux';

import { ConceptFeedback as SharedConceptFeedback } from '../../../Shared/index';
import { ActionTypes } from '../../actions/actionTypes';
import * as actions from '../../actions/fillInBlankConceptsFeedback';
import { Match } from '../../interfaces/match';
import { FillInBlankConceptsFeedbackState } from '../../reducers/fillInBlankConceptsFeedbackReducer';
import { ConceptReducerState } from '../../reducers/conceptsReducer';

interface FillInBlankConceptFeedbackComponentProps {
  concepts: ConceptReducerState;
  conceptsFeedback: FillInBlankConceptsFeedbackState;
  dispatch: Function;
  match: Match;
}

class FillInBlankConceptFeedbackComponent extends React.Component<FillInBlankConceptFeedbackComponentProps> {
  handleCancelEdit = (feedbackID: string) => {
    const { dispatch } = this.props;
    dispatch(actions.cancelConceptsFeedbackEdit(feedbackID));
  };

  handleDeleteConceptsFeedback = (feedbackID: string) => {
    const { dispatch } = this.props;
    dispatch(actions.deleteConceptsFeedback(feedbackID));
  };

  handleSubmitNewFeedback = (feedbackID: string, data: any) => {
    const { dispatch } = this.props;
    dispatch(actions.submitConceptsFeedbackEdit(feedbackID, data));
  };

  handleToggleEdit = (feedbackID: string) => {
    const { dispatch } = this.props;
    dispatch(actions.startConceptsFeedbackEdit(feedbackID));
  };

  render() {
    const { concepts, conceptsFeedback, match } = this.props;

    return (
      <SharedConceptFeedback
        concepts={concepts}
        conceptsFeedback={conceptsFeedback}
        containerClassName="container"
        editingStateConstant={ActionTypes.START_FITB_CONCEPTS_FEEDBACK_EDIT}
        match={match}
        onCancelEdit={this.handleCancelEdit}
        onDeleteConceptsFeedback={this.handleDeleteConceptsFeedback}
        onStartEdit={this.handleToggleEdit}
        onSubmitNewFeedback={this.handleSubmitNewFeedback}
        showTranslation={false}
      />
    );
  }
}

function select(state: any) {
  return {
    concepts: state.concepts,
    conceptsFeedback: state.fillInBlankConceptsFeedback,
    questions: state.questions,
  };
}

function mergeProps(stateProps: Object, dispatchProps: Object, ownProps: Object) {
  return { ...ownProps, ...stateProps, ...dispatchProps };
}

export default connect(
  select,
  (dispatch) => ({ dispatch }),
  mergeProps
)(FillInBlankConceptFeedbackComponent);
